import React, { Component } from 'react';
import { FaExclamationCircle as Warning, FaCheckCircle as Ok, FaTimesCircle as Error, FaChevronRight as Next, FaChevronLeft as Previous } from 'react-icons/fa';
import Loader from 'react-loader-advanced';
import HttpClient from "../../../libs/http";
const http = new HttpClient()
const qs = require('query-string')
const query = qs.parse(window.location.search)
const environment = query.environment || query.env || 'stable'

export default class ResultTable extends Component {
  constructor(props) {
    super(props)
    this.worker = null
    this.state = {
      results: [],
      filter: {
        module: query.module,
        page: query.page || 1,
        PS: query.PS || 100,
        status: query.status || "*",
        from: query.from ? Date.toDate(query.from).toString() : Date.today().toString(),
        to: query.to ? Date.toDate(query.to).toString() : new Date().toString(),
        environment: environment
      },
      last_updated: new Date().toString("HH:mm:ss"),
      loaded: false
    }
  }
  componentWillMount() {
    this.getData()
    this.worker = setInterval(async _ => await this.getData(), 30000)
  }
  componentWillUnmount() {
    if (this.worker) clearInterval(this.worker)
  }
  getData = async () => {
    try {
      let results = await http.GET(`/api/pvt/healthcheck/results?repository=${this.state.filter.environment}`
        + '&module=' + this.state.filter.module
        + '&page=' + this.state.filter.page
        + '&PS=' + this.state.filter.PS
        + '&status=' + this.state.filter.status
        + '&from=' + this.state.filter.from
        + '&to=' + this.state.filter.to)
      let new_state = this.state
      new_state.results = results
      new_state.last_updated = new Date().toString("HH:mm:ss")
      new_state.loaded = true
      this.setState(new_state)
    }
    catch (err) {
      console.log(err)
    }
  }
  
 
  getStatusIcon = (status) => {
    let size = 20;
    switch (status) {
      case 'error':
        return <Error className="red bg-white br4" size={size} />;

      case 'warning':
        return <Warning className="gold bg-white br4" size={size} />;
      default:
        return <Ok className="green bg-white br4" size={size} />;
    }
  }
  each = (item, index) => {
    var bg = item.status !== 'success' ? "bg-dark-red" : (index % 2 === 0 ? "bg-white-10" : "bg-dark-violet");
    item.date = new Date(item.date)
    return (
      <tr key={'result_' + item.id} className={"pointer mv3 tc " + bg} onClick={function () { window.open(`/healthcheck/results/detail?id=${item.id}&environment=${this.state.filter.environment}&month=${item.date.toString("yyyy-MM")}`, '_blank') }.bind(this)}>
        <td headers="ranking" className="dtc pv1 pv2-l ph2 fw8">{(index + 1) || '#0'}</td>
        <td headers="date" className="dtc pv1 pv2-l ph1">
          {item.date.toString("dd/MM/yyyy HH:mm:ss")}
        </td>
        <td headers="status" className="dtc pv1 pv2-l ph3">{this.getStatusIcon(item.status)}</td>
        <td headers="title" className="dtc pv1 pv2-l ph3 tl">{item.title}</td>
        <td headers="module" className="dtc pv1 pv2-l ph3">{item.module}</td>
        <td headers="etime" className="dtc pv1 pv2-l ph3">{item.eTime}</td>
      </tr>
    );
  }
  onChangeDate = (input) => {
    var state = this.state;
    var slited = input.target.value.split("-");
    var month = parseInt(slited[1]) - 1;
    state.date = new Date(slited[0], month, slited[2]);
    state.loading = true;
    this.setState(state);
    this.getData();
  }
  previousPage = () => {
    var state = this.state;
    state.filter.page -= 1;
    if (state.filter.page < 1) state.filter.page = 1
    state.loaded = false;
    this.setState(state);
    this.getData();
  }
  nextPage = () => {
    var state = this.state;
    state.filter.page += 1;
    state.loaded = false;
    this.setState(state);
    this.getData();
  }
  onChange = (event) => {
    var state = this.state;
    state.filter[event.target.name] = (event.target.name == 'from' || event.target.name == 'to') ? Date.toDate(event.target.value).toString() : event.target.value
    this.setState(state);
  }
  onFilter = () => {
    var state = this.state;
    state.loaded = false;
    this.setState(state);
    this.getData();
  }
  render() {
    return (
      <div className="ph2 white">
        <h3 className="w-100 fl mv0 f2 fw1 tc pv4">{this.state.filter.module}<br /><small className="f4">Between ({Date.toDate(this.state.filter.from.slice(0, 16)).toString("dd/MM/yyyy HH:mm")} and {Date.toDate(this.state.filter.to.slice(0, 16)).toString("dd/MM/yyyy HH:mm")})</small></h3>
        <div className="pa3 w-20 fl">
          <span className="w-100 fl pa1">
            <label className="db fw6 lh-copy f6" for="from">From</label>
            <input className="item-center pointer pa2 ma2 br2" type="datetime-local" name="from" id="filter-from" defaultValue={this.state.filter.from.slice(0, 16)} onChange={this.onChange} />
          </span>
          <span className="w-100 fl pa1">
            <label className="db fw6 lh-copy f6" for="to">To</label>
            <input className="item-center pointer pa2 ma2 br2" type="datetime-local" name="to" id="filter-to" defaultValue={this.state.filter.to.slice(0, 16)} onChange={this.onChange} />
          </span>
          <span className="w-50 fl pa1">
            <label className="db fw6 lh-copy f6" for="to">Status</label>
            <select id="filter-status" name="status" className="item-center pointer pa2 ma2 br2" onChange={this.onChange} defaultValue={"*"}>
              <option value="*">All</option>
              <option value={0}>Error</option>
              <option value={2}>Warning</option>
              <option value={1}>Success</option>
            </select>
          </span>
          <span className="w-50 fl pa1">
            <label className="db fw6 lh-copy f6" for="to">Items per page</label>
            <select id="filter-ps" name="PS" className="item-center pointer pa2 ma2 br2" onChange={this.onChange} defaultValue={this.state.filter.PS}>
              <option value={20}>20</option>
              <option value={40}>40</option>
              <option value={60}>60</option>
              <option value={100}>100</option>
            </select>
          </span>
          <span className="w-100 fl pa1 pt2 tc">
            <span className="w-70 fl hover-bg-white item-center hover-black pointer pa3 ma2 br2 f3" onClick={this.onFilter}>
              <span className="pr1">Filter</span>
            </span>
          </span>
          <span className="w-100 fl pa1 tc">
            <span className="hover-bg-white item-center hover-black pointer pa2 ma2 br2" onClick={this.previousPage}>
              <Previous size={20} />
              <span className="pl1 ">Previous</span>
            </span>
            <span className="item-center pa2 ma2 br2">
              <span className="pl1 ">{this.state.filter.page}</span>
            </span>
            <span className="hover-bg-white item-center hover-black pointer pa2 ma2 br2" onClick={this.nextPage}>
              <span className="pr1">Next</span>
              <Next size={20} />
            </span>
          </span>
        </div>
        <div className="pa0 mt4-l flex-l flex-column-l fl w-80">
          <Loader show={!this.state.loaded} message={'Loading...'} backgroundStyle={{ backgroundColor: 'black' }}>
            <div className="items-center flex justify-around">
              <table className="f5 ph2-l flex fl w-100">
                <div className="w-100 mr0 mr2-l">
                  <thead className="w4 white-70 dt-row-group-l">
                    <tr className="w-100">
                      <th id="ranking" className="w-5 fw4">#</th>
                      <th id="date" className="w-20 fw4">Date</th>
                      <th id="status" className="w-5 fw4">Status</th>
                      <th id="title" className="w-50 fw4">Title</th>
                      <th id="module" className="w-20 fw4">Module</th>
                      <th id="etime" className="w-10 fw4">Elapsed Time</th>
                    </tr>
                  </thead>
                  <tbody className="lh-copy white-90">
                    {this.state.results.map(this.each)}
                  </tbody>
                </div>
              </table>
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Healthcheck/ResultTable/index.js